<template>
  <div>
    <v-app id="app">
      <template v-if="$route.meta.auth">
        <div class="wrap">
          <Header />
          <div class="container">
            <Breadcrumbs />
            <transition
              name="fade-transition"
              mode="out-in"
              :duration="{ enter: 100, leave: 100 }"
            >
              <router-view :key="$route.fullPath" />
            </transition>
          </div>
        </div>
        <LodingSpinner :loading="loadingStatus"></LodingSpinner>
      </template>
      <template v-else>
        <keep-alive>
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
      </template>
    </v-app>
  </div>
</template>
<script>
import './assets/scss/style.scss';
import Header from '~@/layout/Header';
import Breadcrumbs from '~@/layout/Breadcrumbs';
import bus from '@/utils/bus';
import LodingSpinner from '~@/common/LoadingSpinner.vue';
export default {
  components: {
    Header,
    Breadcrumbs,
    LodingSpinner,
  },
  data: () => ({
    loadingStatus: false,
  }),
  methods: {
    startSpinner() {
      this.loadingStatus = true;
    },
    endSpinner() {
      this.loadingStatus = false;
    },
  },
  created() {
    bus.$on('start:spinner', this.startSpinner);
    bus.$on('end:spinner', this.endSpinner);
  },
  beforeDestroy() {
    bus.$off('start:spinner', this.startSpinner);
    bus.$off('end:spinner', this.endSpinner);
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Noto Sans KR', '맑은고딕', 'Avenir', Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container {
  padding: 0 48px;
}
</style>
